import store from '@/store'
import { i18n } from '@/i18n'

export const copyText = (text, message) => {
  navigator.clipboard.writeText(text)
  const description = message || i18n.t('general.copied')

  store.dispatch('notification/setNotification', {
    description,
    title: i18n.t('general.success'),
    type: 'success'
  })
}
